import { twMerge } from "tailwind-merge"

const Section: React.FC<{ children: React.ReactNode; padding?: string; maxWidth?: string; className?: string }> = ({
  children,
  className,
}) => (
  <section className={twMerge(`px-[1rem] lg:px-[1rem] max-w-7xl py-[4rem] md:py-[7rem] mx-auto`, className)}>
    {children}
  </section>
)

export default Section
